// extracted by mini-css-extract-plugin
export default {"container":"SelectionGuide_container__MRCN1"};